// extracted by mini-css-extract-plugin
module.exports = {"atm_gi_idpfg4":"atm_gi_idpfg4","atm_cs_8n312b":"atm_cs_8n312b","atm_7l_84nvkm":"atm_7l_84nvkm","s1y1i3tv":"s1y1i3tv"};